var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_vm._v(" Home Page "),_c('FileUpload'),_c('LocaleSwitcher'),_c('br'),_c('br'),_c('v-btn',{attrs:{"color":"success"}},[_vm._v(_vm._s(_vm.$t('common.buttons.new')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }